import React, { useState } from 'react';
import styled from 'styled-components';
import { AssessmentAccordion } from '../../../../Assessment';
import {
  WELCOME_LETTER_TEXT,
  CHECK_INFORMATION_TEXT,
  WELCOME_PERORATION,
  COLLECT_IDENTITY_CARD_TEXT,
} from './lang';

type WelcomeLetterProps = {
  isLocal: boolean;
  studentNumber: string;
};

export const WelcomeLetter: React.FC<WelcomeLetterProps> = (
  props: WelcomeLetterProps,
) => {
  const { isLocal, studentNumber } = props;
  const [expandSurvey, setExpandSurvey] = useState<boolean>(true);
  const [expandAnti, setExpandAnti] = useState<boolean>(true);

  const welcomeLetterList = [
    {
      title: WELCOME_LETTER_TEXT.ACTIVATE_NET_ID,
      assessDetails: WELCOME_LETTER_TEXT.ACTIVATE_NET_ID_TEXT,
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.CHECK_EMAIL,
      assessDetails: WELCOME_LETTER_TEXT.CHECK_EMAIL_TEXT,
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.DOWNLOAD,
      assessDetails: WELCOME_LETTER_TEXT.DOWNLOAD_TEXT,
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.COLLECT_IDENTITY_CARD,
      assessDetails: COLLECT_IDENTITY_CARD_TEXT(isLocal),
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.CHECK_INFORMATION,
      assessDetails: CHECK_INFORMATION_TEXT(isLocal),
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.NON_LOCAL_IDENTITY_CARD,
      assessDetails: WELCOME_LETTER_TEXT.NON_LOCAL_STUDENT_TEXT,
      display: !isLocal,
    },
    {
      title: WELCOME_LETTER_TEXT.ENROLMENT,
      assessDetails: WELCOME_LETTER_TEXT.ENROLMENT_TEXT,
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.HEALTH_CARE,
      assessDetails: WELCOME_LETTER_TEXT.HEALTH_CARE_TEXT,
      display: true,
    },
    {
      title: WELCOME_LETTER_TEXT.ALUMNI_AFFAIR,
      assessDetails: WELCOME_LETTER_TEXT.ALUMNI_AFFAIR_TEXT,
      display: true,
    },
  ];

  const handleExpand = (index: number): void => {
    switch (index) {
      case 3:
        setExpandSurvey(!expandSurvey);
        break;
      case 4:
        setExpandAnti(!expandAnti);
        break;
      default:
        break;
    }
  };

  return (
    <Container>
      <div className="text-left px-2 offer_con mb-4">
        <p>
          {WELCOME_LETTER_TEXT.STUDENT_NUMBER}
          {studentNumber}
        </p>
        {WELCOME_LETTER_TEXT.DEAR_STUDENT}
        <br />
        <br />
      </div>
      {welcomeLetterList.map((item, index) => {
        const { title, assessDetails, display } = item;
        return (
          display && (
            <AssessmentAccordion
              id={`letter-${index}`}
              key={index}
              title={title}
              {...(index === 3
                ? { expanded: expandSurvey }
                : index === 4
                  ? { expanded: expandAnti }
                  : { defaultExpanded: true })}
              onClick={() => {
                handleExpand(index);
              }}
              AssessDetails={
                <div
                  dangerouslySetInnerHTML={{
                    __html: assessDetails,
                  }}
                  className="text-left px-2 offer_con"
                />
              }
            />
          )
        );
      })}

      <div
        dangerouslySetInnerHTML={{
          __html: WELCOME_PERORATION,
        }}
        className="text-left px-2 offer_con mt-10"
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  .offer_con p {
    font-family: 'Helvetica', 'PingFang TC', 'Heiti TC', 'Microsoft JhengHei',
      'Noto Sans T Chinese';
    line-height: 27px;
    font-size: 0.9rem;
    letter-spacing: 0.015em;
    color: #000000;
    margin-bottom: 1rem;
  }

  h2 {
    font-family: 'Raleway', sans-serif, 'PingFang TC', 'Heiti TC',
      'Microsoft JhengHei', 'Noto Sans T Chinese';
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    font-size: 1.2rem;
    letter-spacing: 0.01em;
    color: #000000;
    padding: 16px 0;
  }

  a {
    color: #b85661;
  }

  .con_collapse {
    margin-bottom: 1rem;
  }

  .con_collapse tbody tr td {
    background: rgba(228, 148, 153, 0.3);
    font-family: 'Helvetica', 'PingFang TC', 'Heiti TC', 'Microsoft JhengHei',
      'Noto Sans T Chinese';
    line-height: 27px;
    font-size: 18px;
    letter-spacing: 0.015em;
    color: #181818;
    border: 2px solid #ffffff;
  }

  .con_collapse .header_table {
    background-color: #b85661;
  }

  .con_collapse .header_table tr th {
    font-family: 'Raleway', sans-serif, 'PingFang TC', 'Heiti TC',
      'Microsoft JhengHei', 'Noto Sans T Chinese';
    font-style: normal;
    font-weight: 600;
    line-height: 25px;
    font-size: 18px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #ffffff;
    border: 2px solid #ffffff;
  }

  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
    margin-bottom: 1rem;
  }

  tr {
    padding: 0.95rem;
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
  }

  td {
    font-size: 0.9rem !important;
    padding: 0.5rem;
  }

  th {
    font-size: 0.9rem !important;
    padding: 0.5rem;
  }

  .text-bottom {
    margin-bottom: 0 !important;
  }
`;
